// infcode_change - metrics foundation

/** 事件 URI 常量。语法 `{domain}/{resource}/{operation_or_metric}`，见 event_tracking_rs 埋点规范。 */
export const MetricsUri = {
  turnStart: "agent/turn/start",
  turnEnd: "agent/turn/execution",
  turnRetry: "agent/turn/retry",
  requestChatStart: "request/chat/start",
  requestChatEnd: "request/chat/end",
  requestAgentStart: "request/agent/start",
  requestAgentEnd: "request/agent/end",
  requestPlanStart: "request/plan/start",
  requestPlanEnd: "request/plan/end",
  requestCompletionStart: "request/completion/start",
  requestCompletionEnd: "request/completion/end",
  requestRulesHit: "request/rules/hit",
  requestSkillsHit: "request/skills/hit",
  requestMcpHit: "request/mcp/hit",
  llmRequest: "llm/request/start",
  // infcode_change - GUI submit to the first actual model/generate HTTP request.
  llmSubmitToRequest: "llm/request/submit_to_request_latency",
  llmRequestEnd: "llm/request/total_latency",
  llmFirstToken: "llm/request/first_token_latency",
  llmOutputInterval: "llm/request/output_interval",
  llmEmptyResponse: "llm/request/empty_response",
  // infcode_change - max-token T2（docs/design-docs/2026-09-15-max-token-budget-design.md D5）：
  // 截断率与续跑成本埋点，metadata 带窗口分桶，供 A5 定 max output 策略。
  llmTruncated: "llm/request/truncated",
  llmContinuationInputTokens: "llm/request/continuation_input_tokens",
  // infcode_change start - todo-projection T3：发送边界观测（envelope-observe.v1），
  // metadata 携带来源 breakdown/占比/revision/headroom/估算方法/flag，value = estimatedTokens。
  llmEnvelope: "llm/request/envelope",
  // infcode_change end
  llmInputTokens: "llm/request/input_tokens",
  llmOutputTokens: "llm/request/output_tokens",
  llmReasoningTokens: "llm/request/reasoning_tokens",
  llmCacheReadTokens: "llm/request/cache_read_tokens",
  llmCacheWriteTokens: "llm/request/cache_write_tokens",
  llmTotalTokens: "llm/request/total_tokens",
  agentCoreError: "agent/core/error",
  // Final Response 收口观测（终态回答版）：value = 1（每 turn 一条）；
  // metadata 只带低基数交付口径 committed / reason / zeroDelivery / answerPartCount。
  finalResponseClose: "agent/final_response/close",
  // Final Response 交付延迟：value = turn 创建 → 回答提交（没有回答时取收口时间），metadata 带 committed / reason。
  finalResponseLatency: "agent/final_response/delivery_latency",
  // infcode_change start - 7140500787：会话标题生成结果观测（失败率按 status 统计，分模型可拆）。
  // 挂 agent 域：治理测试的扫描域由注册 URI 的首段派生，新增 session 域会让
  // KiloJsonApiClient.kt 的 API 路径 session/status 被误判为未注册事件 URI。
  titleGenerate: "agent/title/generate",
  // infcode_change end
  compactionTriggerAuto: "compaction/trigger/auto",
  compactionTriggerManual: "compaction/trigger/manual",
  compactionRun: "compaction/summary/run",
  compactionOverflow: "compaction/context/overflow",
  uiChatView: "ui/chat/view",
  uiHomeView: "ui/home/view",
  uiConfigView: "ui/config/view",
  uiMcpMarketView: "ui/mcp_market/view",
  uiLoginView: "ui/login/view",
  uiUnauthorizedView: "ui/unauthorized/view",
  uiOtherView: "ui/other/view",
  webviewRuntimeUnhandledError: "webview/runtime/unhandled_error",
  webviewPerfLongTask: "webview/perf/long_task",
  webviewLoadBridgeReady: "webview/load/bridge_ready",
  webviewLoadFirstRender: "webview/load/first_render",
  webviewLoadFirstSession: "webview/load/first_session",
  pluginRuntimeError: "plugin/runtime/error",
  pluginThreadEdtViolation: "plugin/thread/edt_violation",
  pluginPerfSlowEdt: "plugin/perf/slow_edt",
  pluginPerfSlowHandler: "plugin/perf/slow_handler",
  pluginStartupTotal: "plugin/startup/total",
  // opencode 自身资源采样（§6.7）：gauge 走 Metrics.performance，越界走 Metrics.error。
  processRss: "opencode/process/rss",
  processCpu: "opencode/process/cpu",
  processHighMemory: "opencode/process/high_memory",
  processUnresponsive: "opencode/process/unresponsive",
  processExitAbnormal: "opencode/process/exit_abnormal",
  productInstallFirstStart: "product/install/first_start",
  uiCodeBlockShown: "ui/code_block/shown",
  uiCodeBlockCopy: "ui/code_block/copy",
  uiCodeBlockApply: "ui/code_block/apply",
  uiDiffReviewAccept: "ui/diffreview/accept",
  uiDiffReviewReject: "ui/diffreview/reject",
  uiCompletionShown: "ui/completion/shown",
  uiCompletionAccept: "ui/completion/accept",
  uiCompletionReject: "ui/completion/reject",
  uiRulesHit: "ui/rules/hit",
  uiSkillsHit: "ui/skills/hit",
  uiMcpHit: "ui/mcp/hit",
  uiHistoryOpen: "ui/history/open",
  uiHistoryClose: "ui/history/close",
  uiHistorySearch: "ui/history/search",
  uiHistoryLoadMore: "ui/history/load_more",
  uiHistoryOpenSession: "ui/history/open_session",
  uiHistoryRename: "ui/history/rename",
  uiHistoryDelete: "ui/history/delete",
  uiHistoryCopyId: "ui/history/copy_id",
  uiConfigGeneralView: "ui/config/general/view",
  uiConfigPersonalDataView: "ui/config/personal_data/view",
  uiConfigPersonalDataOpenDashboard: "ui/config/personal_data/open_dashboard",
  uiConfigAgentView: "ui/config/agent/view",
  uiConfigSubagentView: "ui/config/subagent/view",
  uiConfigMcpView: "ui/config/mcp/view",
  uiConfigHooksView: "ui/config/hooks/view",
  uiConfigMemoryView: "ui/config/memory/view",
  uiConfigRulesSkillsView: "ui/config/rules_skills/view",
  uiConfigSkillsView: "ui/config/skills/view",
  uiConfigCodeReviewView: "ui/config/code_review/view",
  uiConfigWorktreesView: "ui/config/worktrees/view",
  uiWorktreesSettingsUpdate: "ui/worktrees/settings_update",
  uiWorktreesRetain: "ui/worktrees/retain",
  uiWorktreesOpenManagement: "ui/worktrees/open_management",
  worktreeDelete: "worktree/delete",
  worktreeCreateBlocked: "worktree/create_blocked",
  uiConfigContextView: "ui/config/context/view",
  uiConfigBrowserView: "ui/config/browser/view",
  uiConfigAboutView: "ui/config/about/view",
  uiMcpInstall: "ui/mcp/install",
  uiMcpRemove: "ui/mcp/remove",
  uiMcpConnect: "ui/mcp/connect",
  uiMcpDisconnect: "ui/mcp/disconnect",
  uiMcpRestart: "ui/mcp/restart",
  uiMcpAuthenticate: "ui/mcp/authenticate",
  uiMcpOpenConfig: "ui/mcp/open_config",
  uiMcpAddMarketClick: "ui/mcp/add_market_click",
  uiMcpSetAutoRun: "ui/mcp/set_auto_run",
  uiHooksScopeSwitch: "ui/hooks/scope_switch",
  uiHooksList: "ui/hooks/list",
  uiHooksOpenConfig: "ui/hooks/open_config",
  uiHooksCreate: "ui/hooks/create",
  uiHooksEdit: "ui/hooks/edit",
  uiHooksSetEnabled: "ui/hooks/set_enabled",
  uiHooksExecutionDisplay: "ui/hooks/execution_display",
  uiHooksDelete: "ui/hooks/delete",
  uiRulesCreate: "ui/rules/create",
  uiRulesEdit: "ui/rules/edit",
  uiRulesDelete: "ui/rules/delete",
  uiRulesViewMore: "ui/rules/view_more",
  uiSkillsUpload: "ui/skills/upload",
  uiSkillsDelete: "ui/skills/delete",
  uiSkillsViewMore: "ui/skills/view_more",
  uiComposerModelSelect: "ui/composer/model_select",
  uiComposerAgentSelect: "ui/composer/agent_select",
  uiComposerAttachImage: "ui/composer/attach_image",
  uiComposerRemoveImage: "ui/composer/remove_image",
  uiComposerMention: "ui/composer/mention",
  uiComposerFeedbackOpen: "ui/composer/feedback_open",
  uiComposerWorktreeTargetSelect: "ui/composer/worktree_target_select",
  uiComposerQueueSubmit: "ui/composer/queue_submit",
  uiComposerContextCompact: "ui/composer/context_compact",
  uiSessionTabCreate: "ui/session_tab/create",
  uiSessionTabSwitch: "ui/session_tab/switch",
  uiSessionTabClose: "ui/session_tab/close",
  uiSessionTabRestore: "ui/session_tab/restore",
  uiMessageQueueOpen: "ui/message_queue/open",
  uiMessageQueueRemove: "ui/message_queue/remove",
  uiMessageQueueClear: "ui/message_queue/clear",
  uiMessageQueueRetry: "ui/message_queue/retry",
  uiMessageQueueDrain: "ui/message_queue/drain",
  uiPlanBuild: "ui/plan/build",
  uiPlanContinue: "ui/plan/continue",
  uiPlanCancel: "ui/plan/cancel",
  uiFeedbackLike: "ui/feedback/like",
  uiFeedbackDislike: "ui/feedback/dislike",
  uiFeedbackReasonSubmit: "ui/feedback/reason_submit",
  // memory lifecycle (business metadata is sent flat through Metrics.performance)
  memoryRuntimeCheck: "memory/runtime_check",
  memoryExtractionStarted: "memory/extraction_started",
  memoryExtractionFinished: "memory/extraction_finished",
  memoryPhase1LlmStarted: "memory/phase1_llm_started",
  memoryWritten: "memory/memory_written",
  memoryIndexLoaded: "memory/index_loaded",
  memoryRead: "memory/memory_read",
  memoryPhase2Started: "memory/phase2_started",
  memoryPhase2Finished: "memory/phase2_finished",
  memoryPhase2InputTruncated: "memory/phase2_input_truncated",
  memoryPhase2LlmStarted: "memory/phase2_llm_started",
  memoryPhase2RepairLlmStarted: "memory/phase2_repair_llm_started",
  memoryDreamStarted: "memory/dream_started",
  memoryDreamRejected: "memory/dream_rejected",
  memoryDreamFinished: "memory/dream_finished",
  memoryDreamLlmStarted: "memory/dream_llm_started",
  memorySessionSummary: "memory/session_summary",
  uiAuthLoginClick: "ui/auth/login_click",
  uiAuthLoginStart: "ui/auth/login_start",
  uiAuthPrivateLoginOpen: "ui/auth/private_login_open",
  uiAuthPrivateLoginConfirm: "ui/auth/private_login_confirm",
  uiAuthLogout: "ui/auth/logout",
  uiPermissionApprove: "ui/permission/approve",
  uiPermissionReject: "ui/permission/reject",
  uiQuestionReply: "ui/question/reply",
  uiQuestionReject: "ui/question/reject",
  uiCheckpointRollback: "ui/checkpoint/rollback",
  uiCheckpointUndoRollback: "ui/checkpoint/undo_rollback",
  uiReviewOpenIssueLocation: "ui/review/open_issue_location",
  uiReviewIgnoreAll: "ui/review/ignore_all",
  uiReviewFixSelected: "ui/review/fix_selected",
  uiReviewReportLoad: "ui/review/report_load",
  uiBrowserApprovalSet: "ui/browser/approval_set",
  uiBrowserInternalToggle: "ui/browser/internal_toggle",
  uiBrowserSearchEngineSet: "ui/browser/search_engine_set",
  uiBrowserCustomSearchAdd: "ui/browser/custom_search_add",
  uiBrowserCustomSearchRemove: "ui/browser/custom_search_remove",
  uiBrowserSitePermissionUpsert: "ui/browser/site_permission_upsert",
  uiBrowserSitePermissionRemove: "ui/browser/site_permission_remove",
  uiBrowserDataClear: "ui/browser/data_clear",
  uiKnowledgeList: "ui/knowledge/list",
  uiKnowledgeCreate: "ui/knowledge/create",
  uiKnowledgeUpdate: "ui/knowledge/update",
  uiKnowledgeDelete: "ui/knowledge/delete",
  uiKnowledgeIndex: "ui/knowledge/index",
  uiKnowledgeDocumentConvert: "ui/knowledge/document_convert",
  uiKnowledgeDocumentUpload: "ui/knowledge/document_upload",
  uiDeepmapListProjects: "ui/deepmap/list_projects",
  uiDeepmapListLinkedRepos: "ui/deepmap/list_linked_repos",
  uiDeepmapUpdateConfig: "ui/deepmap/update_config",
  uiDeepmapLinkRepo: "ui/deepmap/link_repo",
  uiDeepmapUnlinkRepo: "ui/deepmap/unlink_repo",
  uiCodeReviewRequirementsListGlobal: "ui/code_review_requirements/list_global",
  uiCodeReviewRequirementsListProject: "ui/code_review_requirements/list_project",
  uiCodeReviewRequirementsCreate: "ui/code_review_requirements/create",
  uiCodeReviewRequirementsUpdate: "ui/code_review_requirements/update",
  uiCodeReviewRequirementsDelete: "ui/code_review_requirements/delete",
} as const

export type MetricsUriValue = (typeof MetricsUri)[keyof typeof MetricsUri]

export type QueryMode = "chat" | "agent" | "plan" | "completion"
export type QueryMetric =
  | "submit"
  | "close"
  | "first_visible_output"
  | "step_count"
  | "user_abort"
  | "first_ai_activation"
export type QueryUri = `query/${QueryMode}/${QueryMetric}`

/** Query lifecycle URI: `query/{mode}/{metric}`. `mode` and `metric` are controlled enums. */
export function queryUri(mode: QueryMode, metric: QueryMetric): QueryUri {
  return `query/${mode}/${metric}`
}

/**
 * 客户端（webview / plugin）经 HTTP `/infcode/event-tracking` 上报的质量/性能事件白名单。
 * key 即 `CaptureInput.event`（同时就是上报 URI），value 固定该事件的 kind。
 * 未登记的 event 一律拒绝（遵守 single-pipeline 注册制治理，不按模板生成 URI）。
 *
 * 说明：`opencode/process/{unresponsive,exit_abnormal}` 由 plugin 观测 opencode 进程后上报，
 * 故走客户端 HTTP 入口；而 `opencode/process/{rss,cpu,high_memory}` 由 opencode 自身采样、
 * 直接走进程内 `Metrics.*`，不在本表。
 */
export const CLIENT_REPORTABLE_URI = {
  "ui/worktrees/settings_update": "performance",
  "ui/worktrees/retain": "performance",
  // webview
  "webview/runtime/unhandled_error": "error",
  "webview/perf/long_task": "performance",
  "webview/load/bridge_ready": "performance",
  "webview/load/first_render": "performance",
  "webview/load/first_session": "performance",
  // plugin（vscode / jetbrains 由公共字段 platform 区分）
  "plugin/runtime/error": "error",
  "plugin/thread/edt_violation": "error",
  "plugin/perf/slow_edt": "performance",
  "plugin/perf/slow_handler": "performance",
  // 启动观测：成功/失败/超时都用这一个 performance 事件的 status 表达（§6.2），不再分阶段、不再单独 failed
  "plugin/startup/total": "performance",
  // plugin 观测到的 opencode 进程异常
  "opencode/process/unresponsive": "error",
  "opencode/process/exit_abnormal": "error",
  // GUI behavior events with async success/failure status.
  "ui/history/load_more": "performance",
  "ui/history/open_session": "performance",
  "ui/history/rename": "performance",
  "ui/history/delete": "performance",
  "ui/config/personal_data/open_dashboard": "performance",
  "ui/mcp/install": "performance",
  "ui/mcp/remove": "performance",
  "ui/mcp/connect": "performance",
  "ui/mcp/disconnect": "performance",
  "ui/mcp/restart": "performance",
  "ui/mcp/authenticate": "performance",
  "ui/mcp/set_auto_run": "performance",
  "ui/hooks/list": "performance",
  "ui/hooks/open_config": "performance",
  "ui/hooks/create": "performance",
  "ui/hooks/edit": "performance",
  "ui/hooks/set_enabled": "performance",
  "ui/hooks/execution_display": "performance",
  "ui/hooks/delete": "performance",
  "ui/rules/create": "performance",
  "ui/rules/edit": "performance",
  "ui/rules/delete": "performance",
  "ui/skills/upload": "performance",
  "ui/skills/delete": "performance",
  "ui/composer/attach_image": "performance",
  "ui/composer/context_compact": "performance",
  "ui/session_tab/create": "performance",
  "ui/session_tab/restore": "performance",
  "ui/message_queue/retry": "performance",
  "ui/message_queue/drain": "performance",
  "ui/plan/build": "performance",
  "ui/plan/continue": "performance",
  "ui/plan/cancel": "performance",
  "ui/feedback/like": "performance",
  "ui/feedback/dislike": "performance",
  "ui/feedback/reason_submit": "performance",
  "ui/auth/login_start": "performance",
  "ui/auth/private_login_confirm": "performance",
  "ui/auth/logout": "performance",
  "ui/permission/approve": "performance",
  "ui/permission/reject": "performance",
  "ui/question/reply": "performance",
  "ui/question/reject": "performance",
  "ui/checkpoint/rollback": "performance",
  "ui/checkpoint/undo_rollback": "performance",
  "ui/review/report_load": "performance",
  "ui/browser/approval_set": "performance",
  "ui/browser/internal_toggle": "performance",
  "ui/browser/search_engine_set": "performance",
  "ui/browser/custom_search_add": "performance",
  "ui/browser/custom_search_remove": "performance",
  "ui/browser/site_permission_upsert": "performance",
  "ui/browser/site_permission_remove": "performance",
  "ui/browser/data_clear": "performance",
  "ui/knowledge/list": "performance",
  "ui/knowledge/create": "performance",
  "ui/knowledge/update": "performance",
  "ui/knowledge/delete": "performance",
  "ui/knowledge/index": "performance",
  "ui/knowledge/document_convert": "performance",
  "ui/knowledge/document_upload": "performance",
  "ui/deepmap/list_projects": "performance",
  "ui/deepmap/list_linked_repos": "performance",
  "ui/deepmap/update_config": "performance",
  "ui/deepmap/link_repo": "performance",
  "ui/deepmap/unlink_repo": "performance",
  "ui/code_review_requirements/list_global": "performance",
  "ui/code_review_requirements/list_project": "performance",
  "ui/code_review_requirements/create": "performance",
  "ui/code_review_requirements/update": "performance",
  "ui/code_review_requirements/delete": "performance",
} as const satisfies Partial<Record<MetricsUriValue, "error" | "performance">>

export type ClientReportableUri = keyof typeof CLIENT_REPORTABLE_URI & MetricsUriValue

/** 返回该 event 登记的 kind；未登记返回 undefined（即拒绝上报）。 */
export function clientReportableKind(event: string): "error" | "performance" | undefined {
  return (CLIENT_REPORTABLE_URI as Record<string, "error" | "performance">)[event]
}

export type HttpScope = "llm_provider" | "infcode_api"
export type HookEventKey =
  | "user_prompt_submit"
  | "pre_tool_use"
  | "post_tool_use"
  | "post_tool_use_failure"
  | "stop"
  | "session_start"
  | "session_end"
  | "turn_start"
  | "turn_end"
  | "pre_llm_request"
  | "post_llm_response"
  | "permission_request"
  | "permission_result"
  | "subagent_start"
  | "subagent_stop"
export type HookMetric = "execution" | "block" | "skip" | "drop"
export type ToolUri = `tool/${string}/execution`
export type HttpUri = `http/${HttpScope}/request`
export type HookUri = `hook/${HookEventKey}/${HookMetric}`
export type RegisteredMetricUri = MetricsUriValue | ClientReportableUri | QueryUri | ToolUri | HttpUri | HookUri

const TOOL_KEY_PATTERN = /^[a-z][a-z0-9_]*$/

/** 工具执行 URI：`tool/{tool_key}/execution`；非法或未注册 key 回退 `tool/other/execution`。 */
export function toolUri(toolName: string): ToolUri {
  const normalized = toolName.trim().toLowerCase().replace(/-/g, "_")
  const key = TOOL_KEY_PATTERN.test(normalized) ? normalized : "other"
  return `tool/${key}/execution`
}

/** HTTP 请求观测 URI：`http/{scope}/request`。 */
export function httpUri(scope: HttpScope): HttpUri {
  return `http/${scope}/request`
}

/** Hook 运行时 URI：`hook/{event}/{metric}`；event 与 metric 都是受控低基数枚举。 */
export function hookUri(event: HookEventKey, metric: HookMetric): HookUri {
  return `hook/${event}/${metric}`
}

/** event_tracking_rs 0.2.2 PerformanceStatus 枚举数值（Success=0/Error=1/Timeout=2/Cancelled=3） */
export const STATUS_CODE = {
  success: 0,
  error: 1,
  timeout: 2,
  cancelled: 3,
} as const

export type MetricsStatus = keyof typeof STATUS_CODE
